<div class="address-page d-flex flex-column">
    <!-- Header -->
    <header class="address-header d-flex align-items-center px-3 py-2">
      <button class="back-button me-2" (click)="goBack()">
        <i class="fas fa-arrow-left"></i>
      </button>
      <h1 class="page-title mb-0">My Addresses</h1>

      <button class="btn add-button" (click)="navigateToNewAddress()" aria-label="Add address">
        <i class="fas fa-plus fa-lg"></i>
      </button>
    </header>
  
    <!-- Main Content -->
    <main class="flex-fill container py-3">
      <!-- Skeleton Loader -->
      <ng-container *ngIf="!addressesLoaded">
        <div *ngFor="let _ of [0, 1]" class="card mb-3" aria-hidden="true">
          <div class="card-body placeholder-glow">
            <h5 class="placeholder col-8"></h5>
            <p class="placeholder col-5"></p>
          </div>
        </div>
      </ng-container>
  
      <!-- Address Cards -->
      <div class="row g-3" *ngIf="addressesLoaded && addresses.length">
        <div class="col-12 col-md-6 col-lg-4" *ngFor="let item of addresses; let i = index">
          <div class="card address-card p-3">
            <div class="d-flex align-items-start">
              <i class="fas fa-location-dot fa-lg text-primary me-3"></i>
              <div class="flex-grow-1">
                <p class="fw-semibold mb-1">{{ item.title }}</p>
                <p class="text-muted mb-0">{{ item.address }}</p>
              </div>
              <div class="text-end position-relative">
                <span
                  *ngIf="item.primaryAddress === 1"
                  class="badge bg-success mb-1"
                  >Primary</span
                >
                <button
                  class="btn btn-link p-0"
                  (click)="toggleActions(i)"
                  aria-label="Actions"
                >
                  <i class="fas fa-ellipsis-v"></i>
                </button>
                <div *ngIf="activeIndex === i" class="action-list">
                  <button class="btn btn-sm btn-link w-100 text-start" (click)="edit(i, item.addressId)">
                    <i class="fas fa-edit me-1"></i>Edit
                  </button>
                  <button
                    class="btn btn-sm btn-link text-danger w-100 text-start"
                    (click)="remove(item.addressId)"
                  >
                    <i class="fas fa-trash me-1"></i>Remove
                  </button>
                  <button class="btn btn-sm btn-link w-100 text-start" (click)="select(item.addressId)">
                    <i class="fas fa-star me-1"></i>Make Primary
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <!-- Empty State -->
      <div *ngIf="addressesLoaded && !addresses.length" class="empty-state-card mx-auto text-center p-4">
        <i class="fas fa-location-dot fa-3x text-secondary mb-3"></i>
        <h4 class="mb-2">No Addresses found!</h4>
        <p class="text-muted">Looks like you haven't added any address yet.</p>
      </div>
    </main>
  
    <!-- Footer -->
    <!-- <footer class="footer px-3 py-2 bg-white border-top">
      <button
        type="button"
        class="btn btn-primary w-100 d-flex align-items-center justify-content-center"
        (click)="navigateToNewAddress()"
      >
        <i class="fas fa-plus me-2"></i> Add new address
      </button>
    </footer> -->
  </div>
  
